const collection = {
  slug: "comme-des-garcons-2015ss-roses-and-blood-guide",
  metaTitle:
    "コムデギャルソン名作『Roses & Blood』薔薇と血とは｜2015SS赤い薔薇と血のコレクション買取ガイド",
  metaDescription:
    "COMME des GARÇONS 2015SS『Roses & Blood』を解説。黒ではなく鮮烈な赤でランウェイを支配し、薔薇、血、革命、宗教、戦争、美しさと暴力性を重ねた川久保玲の名作コレクション。コムデギャルソン名作、アーカイブ価値、買取相談までEnclopediaが詳しく案内します。",
  metaKeywords:
    "コムデギャルソン Roses and Blood,COMME des GARCONS 2015SS,Roses & Blood,コムデギャルソン 名作,コムデギャルソン 赤,コムデギャルソン 薔薇,コムデギャルソン 血,川久保玲 名作,COMME des GARCONS Spring 2015,コムデギャルソン 2015SS,コムデギャルソン アーカイブ,COMME des GARCONS アーカイブ,コムデギャルソン 買取,COMME des GARCONS 買取,コムデギャルソン 高価買取,コムデギャルソン 古着 買取,コムデギャルソン レディース 買取,Enclopedia,アンクロペディア",
  canonicalPath:
    "/archive_collection/comme-des-garcons-2015ss-roses-and-blood-guide",
  heroImage: "media/archive_fashion/archive10.png",
  heroImageAlt:
    "COMME des GARÇONS 2015SS Roses and Blood 赤い薔薇と血を解説するEnclopediaアーカイブガイド画像",
  heroNumber: "11 / ROSES & BLOOD",
  label: "ARCHIVE COLLECTION STUDY",
  title: "COMME des GARÇONS 2015SS『Roses & Blood』",
  lead: "COMME des GARÇONS 2015SS『Roses & Blood』。\n\nCOMME des GARÇONSを象徴する色として語られてきた「黒」は、このシーズンで姿を潜めました。\nランウェイを支配したのは、鮮烈な赤。\nテーマは、薔薇と血。\n\n薔薇という言葉から連想される甘美さやロマンスは、ここでは単純な美しさとして扱われていません。\nそれは政治、戦争、宗教、革命の中に現れる、血を伴った薔薇です。\n\n美しいのに、どこか恐ろしい。\n華やかなのに、祝祭ではなく犠牲の気配がある。\nこの赤は、装飾の色ではありません。\n意志の色であり、抵抗の色であり、流された血の色でもあります。",
  keywordLine: ["roses and blood", "red", "rei kawakubo", "buyback guide"],
  thesis:
    "2015SS『Roses & Blood』の重要性は、赤によって美の中に潜む暴力性、革命性、犠牲の気配を露わにした点にあります。",
  whyTitle: "なぜ『Roses & Blood』は、赤いだけのコレクションではないのか。",
  whyBody:
    "COMME des GARÇONSにおいて、黒は長く象徴的な色として語られてきました。\n1982AW『Holes』/『Destroy』では、黒、穴、ほつれ、だぼだぼのシルエットによって、西洋ファッションが前提としていた華やかさや身体美を壊しました。\n\nしかし2015SS『Roses & Blood』では、黒ではなく赤が中心に置かれます。\n赤は、単なる装飾色ではありません。\n薔薇の赤であり、血の赤であり、戦争、宗教、政治、革命、犠牲を連想させる赤です。\n\n服は花のように膨らみ、裂け、身体を覆い、時に傷口や肉のようにも見えます。\n美しいのに、どこか恐ろしい。\nロマンチックなのに、どこか暴力的。\n\n1982AWが黒によって西洋的な美の基準を壊したコレクションだとすれば、2015SSは赤によって、美の中に潜む暴力性と革命性を露わにしたコレクションです。\nEnclopediaでは、このような名作の文脈を入口に、コムデギャルソンのアーカイブ価値を読み取り、買取やレンタルを通じて次のユーザーへつなげます。",
  pillars: [
    {
      number: "01",
      title: "RED AS WILL",
      text: "このコレクションの赤は、華やかな色ではありません。意志、抵抗、犠牲、流血の気配を帯びた赤として機能します。",
    },
    {
      number: "02",
      title: "ROSE AS VIOLENCE",
      text: "薔薇は甘美な花であると同時に、政治、宗教、戦争、革命の中で血を伴う象徴にもなります。Roses & Bloodは、その二重性を服に変換しています。",
    },
    {
      number: "03",
      title: "ARCHIVE AS VALUE",
      text: "COMME des GARÇONSの名作は、古い服だから価値があるのではありません。時間が経っても問いが残り、今も読み直せるからアーカイブとして評価されます。",
    },
  ],
  readingTitle: "赤、薔薇、血、革命から読む『Roses & Blood』。",
  readingIntro:
    "このコレクションは、赤い服が並んだから印象的なのではありません。なぜ赤なのか、なぜ薔薇なのか、なぜ美しさが恐ろしさに変わるのかを見ることで、川久保玲のコレクションの強度が見えてきます。",
  observations: [
    {
      index: "01",
      title: "黒ではなく赤を選んだことの強さ",
      text: "COMME des GARÇONSといえば、黒のイメージが強くあります。\n黒は沈黙、拒否、余白、反抗を示す色として、ブランド史の中で重要な役割を持ってきました。\n\nしかし2015SSでは、その黒がほとんど姿を消します。\n代わりにランウェイを支配するのは、全身を染め上げるような赤です。\n\nこの赤は、黒の反対としての華やかさではありません。\nむしろ黒が持っていた反抗性を、より直接的で、肉体的で、感情的なかたちへ変換した色です。",
    },
    {
      index: "02",
      title: "薔薇は、ロマンスだけの花ではない",
      text: "薔薇は、愛、ロマンス、美しさを象徴する花です。\nしかし同時に、政治、戦争、宗教、革命の中にも現れる記号です。\n紋章、聖性、殉教、流血、抵抗。\n\n『Roses & Blood』における薔薇は、甘美な花としてだけでは扱われていません。\n花びらのように膨らむ布は美しく見える一方で、傷口や肉、裂けた身体のようにも見える。\n\n川久保玲は、薔薇を美しさの記号として使いながら、その裏側にある暴力性まで同時に見せています。",
    },
    {
      index: "03",
      title: "服は花のようであり、傷口のようでもある",
      text: "このコレクションの服は、花のように膨らみ、ねじれ、身体の周囲に広がります。\nしかしその赤い量感は、単純に華やかではありません。\n裂け目、切り込み、身体を覆う構造が、どこか傷口や肉のようにも見えてきます。\n\n美しいはずの花が、身体的な痛みを帯びる。\n祝祭的に見える赤が、犠牲の赤へ変わる。\n\nこの曖昧さが、Roses & Bloodを単なるロマンチックなコレクションではなく、強い緊張感を持つ名作にしています。",
    },
    {
      index: "04",
      title: "美しさの中にある暴力性を隠さない",
      text: "ファッションは、美しいものを美しいまま提示することが多い。\nしかし川久保玲は、美しさの中にある不穏さや暴力性を隠しません。\n\n薔薇は美しい。\n赤は華やか。\nドレスは壮麗。\nけれど、その美しさの奥には、血、犠牲、抵抗、革命の気配があります。\n\nRoses & Bloodは、美しさを否定しているのではありません。\n美しさが、時に暴力と隣り合わせであることを見せています。",
    },
    {
      index: "05",
      title: "1982AW『Holes』と対になる赤の衝撃",
      text: "1982AW『Holes』/『Destroy』が、黒によって西洋的な女性美や身体美を壊したコレクションだとすれば、2015SS『Roses & Blood』は、赤によって美の中にある暴力性を露わにしたコレクションです。\n\n1982AWの黒は、華やかさへの拒否でした。\n2015SSの赤は、華やかさの内側にある血を見せる色です。\n\nどちらも、単なる色の選択ではありません。\n色を通して、美しさの基準そのものを揺さぶっています。",
    },
    {
      index: "06",
      title: "“美しいけど怖い”という川久保玲の感覚",
      text: "COMME des GARÇONSの名作には、“美しいけど怖い”という感覚があります。\n2005AW『Broken Bride』では、白い花嫁の美しさの中に、制度や崩壊の不穏さがありました。\n2015SS『Roses & Blood』では、赤い薔薇の美しさの中に、血と革命の気配があります。\n\n美しさをそのまま美しさとして終わらせない。\n美しいものの中にある怖さまで見せてしまう。\nそこに川久保玲のコレクションの深さがあります。",
    },
    {
      index: "07",
      title: "買取で見るべきなのは、古さではなく文脈",
      text: "コムデギャルソンの買取では、単に古い服だから価値がある、という見方では不十分です。\nどのシーズンか。どのラインか。どんなテーマと接続しているか。どれだけブランド史の中で重要か。\n\n2015SS『Roses & Blood』のような象徴的コレクションは、まさに文脈が価値になる代表例です。\nEnclopediaでは、コムデギャルソンの服を単なる古着としてではなく、ブランドの思想やコレクション背景まで含めて確認します。",
    },
  ],
  quote:
    "Roses & Bloodは、赤いドレスのコレクションではない。美しさの中に潜む血と抵抗を、服として立ち上げたコレクションです。",
  perspectiveTitle:
    "Enclopediaは、コムデギャルソンを“古着”ではなく“問いが残るアーカイブ”として見る。",
  perspectiveCards: [
    {
      number: "01",
      title: "KNOWLEDGE",
      text: "2015SS『Roses & Blood』を、赤、薔薇、血、革命、宗教、戦争、川久保玲の美意識から読み解きます。",
    },
    {
      number: "02",
      title: "SERVICE ENTRY",
      text: "この記事は、コムデギャルソンの名作を知る入口であると同時に、Enclopediaが服をどのように読み、扱い、次へつなげるサービスなのかを知ってもらう入口です。",
    },
    {
      number: "03",
      title: "BUYBACK",
      text: "買取対象は2015SSだけに限定しません。COMME des GARÇONS、HOMME PLUS、JUNYA WATANABE、noir kei ninomiyaなど、コムデギャルソン全般を文脈込みで相談対象として見ます。",
    },
  ],
  experienceTitle:
    "コムデギャルソンを売る前に、その一着がどの文脈にあるかを確認する。",
  experienceBody:
    "コムデギャルソンの買取では、ブランド名だけでなく、ライン、年代、シーズン、デザイナー、素材、状態、現在の需要が重要です。\n今回の記事では2015SS『Roses & Blood』を中心に解説していますが、Enclopediaが見ているのはこのシーズンだけではありません。\nCOMME des GARÇONS、COMME des GARÇONS HOMME PLUS、COMME des GARÇONS HOMME、JUNYA WATANABE、noir kei ninomiya、tao COMME des GARÇONSなど、コムデギャルソン全般を対象に、その一着がどの時代のどんな価値を持つのかを確認します。\n名作コレクションを知ることは、自分の持っている一着の価値を見直す入口になります。",
  experienceItems: [
    "COMME des GARÇONSのライン名を確認する",
    "タグ・品質表示・年代・シーズンが分かる写真を撮影する",
    "赤、薔薇、立体的な造形、切り込み、膨らみなどのディテールを確認する",
    "HOMME PLUS、JUNYA、noirなどラインごとの特徴を確認する",
    "2015SSなど名作シーズンに近い文脈があるか確認する",
    "シーズンや価値が分からない場合もLINEで写真を送る",
  ],
  archiveItemsTitle: "コムデギャルソンの名作を入口に、買取相談へつなげる。",
  archiveItemsBody:
    "Enclopediaでは、コムデギャルソンを単なるブランド古着としてではなく、コレクション背景、ライン、年代、思想、現在の需要まで含めて見ています。この記事で2015SS Roses & Bloodの重要性に触れた方は、所有しているコムデギャルソンの一着も、まずはLINEでご相談ください。",
  archiveItems: [
    {
      label: "BUYBACK FOCUS 01",
      title: "コムデギャルソン買取ページへ",
      productPath: "/brand_buyback/comme-des-garcons",
      productImage: "",
      text: "COMME des GARÇONS、HOMME PLUS、HOMME、JUNYA WATANABE、noir kei ninomiyaまで。コムデギャルソン全般の買取対象と査定視点を確認できます。",
    },
    {
      label: "BUYBACK FOCUS 02",
      title: "LINEでコムデギャルソンを事前査定",
      productPath: "https://line.me/R/ti/p/@240yzqkh",
      productImage: "",
      text: "タグ、品質表示、全体写真、ディテール写真を送るだけで、宅配買取へ進む前におおまかな査定方向を確認できます。シーズンが分からない場合も相談可能です。",
    },
    {
      label: "SERVICE FOCUS 03",
      title: "Enclopediaのアーカイブレンタルを見る",
      productPath: "/",
      productImage: "",
      text: "Enclopediaは買取だけでなく、アーカイブを次の人が体験できるレンタルサービスです。服を所有物ではなく、文化として循環させます。",
    },
  ],
  finalCta: {
    title:
      "Roses & Bloodの記事を読んだら、次はEnclopediaでコムデギャルソンの価値を相談する。",
    body: "COMME des GARÇONS 2015SS『Roses & Blood』は、コムデギャルソンの名作を知るための強い入口です。\nただし、Enclopediaが見ているのはこのシーズンだけではありません。\nCOMME des GARÇONS、HOMME PLUS、JUNYA WATANABE、noir kei ninomiyaまで、コムデギャルソン全般の価値をアーカイブの視点で確認します。\nまずはLINEでタグ・品質表示・全体写真をお送りください。",
    buttonLabel: "コムデギャルソンをLINEで事前査定する",
    buttonHref: "https://line.me/R/ti/p/@240yzqkh",
  },
};

export default collection;
